import geClipboardData from '../accessors/get-clipboard-data';

const hasClipboardElementData = () => {
  const clipboard = geClipboardData();
  return Boolean(clipboard && clipboard.element);
};

export default hasClipboardElementData;
